module.exports = __webpack_public_path__ + "img/wrj32.f75737af.svg";